import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import EventPage from './pages/EventPage';
import PrivacyPolicyModal from './components/PrivacyPolicyModal';
import RewindPage from './pages/RewindPage';

function AppRoutes() {
  const location = useLocation();
  const isPrivacy = location.pathname === '/privacy-policy';

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/event/:id" element={<EventPage />} />
        <Route path="/rewind/:id" element={<RewindPage />} />

        <Route path="/privacy-policy" element={<Home />} />
      </Routes>

      {isPrivacy && <PrivacyPolicyModal />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
